/**
 * teamTraining.js — content module for /team-training spoke page.
 * Source: docs/rebuild/content/website/03-offers.md (Card B)
 */

export const teamTrainingHead = {
  eyebrow: 'Team / Enterprise Training',
  heading: 'Team / Enterprise Training',
  subheading: 'One session, done properly. Your team walks out with working mental models, not a certificate.',
};

export const teamTrainingIntro =
  'For organisations whose team uses AI ad-hoc and wants to use it properly. A rinseable curriculum we deliver to your team. Your team walks out with working mental models, not a certificate.';

export const curriculum = {
  heading: 'In the session',
  items: [
    'Claude fundamentals and custom tool use',
    'Claude Projects, MCPs, and connections to the tools you already own',
    'What AI is good for in your team\u2019s actual work, and what it is not',
    'Ethics, dilemmas, and the gotchas that trip every team',
    'The misconceptions people bring in, and what replaces them',
  ],
};

export const whoFits = {
  heading: 'Who this fits',
  items: [
    'Ops, professional services, legal, accounting: any 10+ person team whose AI use is currently ad-hoc',
    'Firms whose compliance or governance layer needs a baseline of safe AI literacy across the team',
    'Teams whose leader has been asked "so what about AI" and wants the answer to be operational, not theoretical',
  ],
};

export const format = {
  heading: 'Format',
  items: [
    'One session, on-site or virtual',
    'Rinseable across multiple teams in the same organisation',
    '10-seat minimum per session',
  ],
};

export const teamTrainingCta = {
  label: 'Scope a session',
};

export const teamTrainingLinks = {
  foundry: { href: '/foundry', label: 'For the founder who wants to build it themselves.' },
  automatedSystems: { href: '/automated-systems', label: 'Upskill your team alongside the build.' },
  systems: { href: '/systems', label: 'AI-native business systems' },
};
